{
  "register": "Đăng ký",
  "login": "Đăng nhập",
  "label": {
    "phoneNumber": "Số điện thoại",
    "password": "Mật khẩu",
    "loginPassword": "Mật khẩu đăng nhập",
    "confirmLoginPassword": "Xác nhận mật khẩu đăng nhập",
    "verificationCode": "Mã xác minh SMS",
    "newPassword": "Mật khẩu mới",
    "confirmNewPassword": "Xác nhận mật khẩu mới",
    "txPassword": "Mật khẩu giao dịch"
  },
  "placeholder": {
    "phoneNumber": "Nhập số điện thoại",
    "password": "Nhập mật khẩu",
    "loginPassword": "Nhập mật khẩu đăng nhập",
    "confirmLoginPassword": "Nhập lại mật khẩu đăng nhập",
    "verificationCode": "Nhập mã xác minh",
    "newPassword": "Nhập mật khẩu mới",
    "confirmNewPassword": "Nhập lại mật khẩu mới"
  },
  "hint": {
    "password": "Ít nhất 8 ký tự, bao gồm số và chữ cái tiếng Anh",
    "mismatch": "Hai mật khẩu không khớp. Vui lòng nhập lại.",
    "phoneNumberInvalid": "Vui lòng nhập số điện thoại hợp lệ",
    "repeatedRegister": "Số điện thoại này đã được sử dụng. Vui lòng nhập lại.",
    "wrongPassword": "Mật khẩu không đúng",
    "passwordInvalid": "Chỉ dùng chữ cái, số và dấu câu thông dụng"
  },
  "toast": {
    "success": {
      "changeLoginPassword": "Đổi mật khẩu đăng nhập thành công",
      "sendVerificationCode": "Đã gửi mã xác minh"
    },
    "error": {
      "loginFailed": "Số điện thoại hoặc mật khẩu không đúng",
      "loginRateLimited": "Bạn đã thử đăng nhập quá nhiều lần. Vui lòng thử lại sau 15 phút.",
      "otpFailed": "Mã xác minh không đúng. Vui lòng nhập lại hoặc lấy mã mới.",
      "otpVerificationRateLimited": "Bạn đã thử xác minh quá nhiều lần. Vui lòng thử lại sau 15 phút.",
      "sendVerificationCode": "Không thể gửi mã xác minh",
      "sendVerificationCodeTooFast": "Yêu cầu mã xác minh quá nhanh. Vui lòng thử lại sau 60 giây.",
      "sendVerificationCodeQuotaReached": "Bạn đã đạt giới hạn yêu cầu mã xác minh. Vui lòng thử lại sau 15 phút.",
      "smsServiceUnavailable": "Dịch vụ SMS tạm thời không khả dụng. Vui lòng thử lại sau.",
      "notRegisteredPhoneNumber": "Số điện thoại này chưa được đăng ký",
      "serverError": "Máy chủ gặp lỗi. Vui lòng thử lại sau.",
      "networkError": "Lỗi mạng. Vui lòng thử lại sau.",
      "timeoutError": "Thao tác đã hết thời gian. Vui lòng thử lại.",
      "changeLoginPasswordFailed": "Không thể đổi mật khẩu đăng nhập. Vui lòng thử lại.",
      "invalidOperation": "Không thể thực hiện thao tác này. Vui lòng làm mới và thử lại.",
      "invalidOperationHint": "Không thể thực hiện thao tác này",
      "noAccess": "Địa chỉ IP này không được phép"
    }
  },
  "country": {
    "China": "Trung Quốc",
    "Taiwan": "Đài Loan",
    "Hong Kong": "Hồng Kông",
    "Thailand": "Thái Lan",
    "United States": "Hoa Kỳ",
    "Russia": "Nga",
    "Netherlands": "Hà Lan",
    "France": "Pháp",
    "Cyprus": "Síp",
    "United Kingdom": "Vương quốc Anh",
    "Poland": "Ba Lan",
    "Malaysia": "Malaysia",
    "Australia": "Úc",
    "Indonesia": "Indonesia",
    "Philippines": "Philippines",
    "Singapore": "Singapore",
    "Japan": "Nhật Bản",
    "Korea": "Hàn Quốc",
    "Macao": "Ma Cao",
    "Cambodia": "Campuchia",
    "Turkey": "Thổ Nhĩ Kỳ",
    "Myanmar": "Myanmar",
    "United Arab Emirates": "Các Tiểu vương quốc Ả Rập Thống nhất",
    "Israel": "Israel"
  },
  "countryOrRegion": "Quốc gia/Khu vực",
  "forgetPassword": "Quên mật khẩu?",
  "clearPhoneNumber": "Xóa số điện thoại",
  "otpDeliveryNotice": "SMS có thể bị chậm. Vui lòng dùng tin nhắn mới nhất nhận được.",
  "noAccount": "Chưa có tài khoản? <0>Đăng ký</0>",
  "haveAccount": "Bạn đã có tài khoản? <0>Đăng nhập</0>",
  "getVerificationCode": "Nhận mã xác minh",
  "retryAfterSeconds": "{{count}} giây",
  "loginExpired": "Phiên đăng nhập đã hết hạn",
  "continue": "Tiếp tục",
  "complete": "Hoàn tất",
  "confirm": "Xác nhận",
  "registerSuccess": "Đăng ký thành công",
  "retrievePassword": "Khôi phục mật khẩu",
  "changeLoginPassword": "Đổi mật khẩu đăng nhập",
  "safetyVerification": "Xác minh bảo mật"
}
